import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DoSettlementComponent } from './do-settlement/do-settlement.component';
import { SettlementDocumentsComponent } from './settlement-documents/settlement-documents.component';
import {SettlementsComponent} from './settlements.component';;


const routes: Routes = [
    {
        path: 'settlements',
        children: [
        { path: 'do-settlement', data: {
          title: 'Do Settlement'
        }, component: DoSettlementComponent},
        { path: 'list', data: {
          title: 'Settlements'
        }, component: SettlementsComponent},
        { path: 'settlement-documents', data: {
          title: 'Settlement Documents'
        }, component: SettlementDocumentsComponent},
        ]
    }

];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })

export class SettlementRoutingModule { }
